import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { ProductDiv } from '../shared/glamorous-style'
import { Message } from '@paypalcorp/worldready-react'

const Header = glamorous.div({
  paddingTop: '36px',
  textAlign: 'center',
  fontSize: '30px',
  fontWeight: '300',
  color: '#4a4a4a',
})

const Button = glamorous.button('vx_btn', {
  width: '270px',
  height: '48px',
  borderRadius: '50px',
  backgroundColor: '#0070ba',
  '@media only screen and (max-width: 768px)': {
    width: '271px',
  },
})

const Content = glamorous.div({
  margin: '0 174px',
  '@media only screen and (max-width: 768px)': {
    margin: '0 12px',
  },
})

const StyledMessage = glamorous.div({
  margin: '35px 0 48px 0',
  fontSize: '18px',
  fontWeight: '300',
  lineHeight: '1.33',
  letterSpacing: 0,
  textAlign: 'center',
  color: '#4a4a4a',
})

const EmptyCart = (props) => (
  <ProductDiv id="cart-summary-page" style={{ height: '669px' }}>
    <Header className="vx_text-2">
      <Message id="pages/cart-summary.cartsummary.emptyCartHeader" />
    </Header>
    <Content>
      <StyledMessage>
        <Message id="pages/cart-summary.cartsummary.emptyCartContent" />
      </StyledMessage>
      <div style={{ textAlign: 'center' }}>
        <Button onClick={props.handleEmptyCartBtnClick}>
          <Message id="pages/cart-summary.cartsummary.emptyCartContinueShopping" />
        </Button>
      </div>
    </Content>
  </ProductDiv>
)

EmptyCart.propTypes = {
  handleEmptyCartBtnClick: PropTypes.func,
}
export default EmptyCart
